import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { FEATURES } from "../../lib/content";
import { Reveal, EASE } from "../Reveal";

export const WhyChoose = () => (
  <section data-testid="why-choose" className="relative bg-dst-ink py-24 lg:py-36 grain">
    <div className="container-dst relative z-10">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 items-end mb-16">
        <Reveal>
          <span className="eyebrow text-dst-red">Why Choose DST</span>
          <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl">
            Built To<br />Develop<br /><span className="text-stroke-red">Competitors</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-white/60 text-lg leading-relaxed max-w-lg lg:justify-self-end">
            We don't chase quick fixes. Every athlete who walks through our doors gets a coach invested in their long-term development — physically, mentally, and competitively.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {FEATURES.map((f, i) => {
          const Icon = Icons[f.icon] || Icons.Dumbbell;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: EASE }}
              data-testid={`feature-${i}`}
              className="group relative bg-dst-ink p-8 lg:p-10 hover:bg-dst-surface transition-colors duration-500"
            >
              <div className="absolute top-6 right-8 font-oswald text-white/5 text-6xl font-700 group-hover:text-dst-red/20 transition-colors">
                0{i + 1}
              </div>
              <div className="w-14 h-14 grid place-items-center bg-dst-red/10 text-dst-red group-hover:bg-dst-red group-hover:text-white transition-colors duration-500 mb-6">
                <Icon size={26} />
              </div>
              <h3 className="font-oswald uppercase tracking-tight text-2xl mb-3">{f.title}</h3>
              <p className="text-white/55 leading-relaxed">{f.text}</p>
              <div className="mt-6 h-0.5 w-0 bg-dst-red group-hover:w-16 transition-all duration-500" />
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
